export { default } from "./XIcon";
